module.exports = __webpack_public_path__ + "img/man.7a110e05.svg";